import { GetOcrAccountsApi } from "@/features/accounts/ocr/services/get-accounts-api";
import { GetOcrAccountsRequestModel } from "@/features/accounts/ocr/services/get-accounts-model";

/// OCR口座一覧取得処理
export class GetOcrAccountsService {
  private getOcrAccountsApi = new GetOcrAccountsApi();

  /**
   * OCR口座一覧取得API実行
   */
  public async getOcrAccounts(param: GetOcrAccountsRequestModel) {
    return await this.getOcrAccountsApi.getOcrAccounts(param);
  }
}
